const accountRouter = [{
		path: '/template_matches/new',
		name: 'template-matches',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/template-matches'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/template_matches/user-current-state',
		name: 'user-current-state',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/user-current-state'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/job/intentions',
		name: 'intention',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/intentions/index'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/users/index',
		name: 'user-index',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/index'),
		meta: {
		}
	},
	{
		path: '/account/users/vue_basic_info',
		name: 'user-basic-info',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/basic_info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/users/setting',
		name: 'user-setting',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/setting'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/feedbacks/new',
		name: 'user-feedbacks',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/feedbacks'),
		meta: {
		}
	},
	{
		path: '/account/orders',
		name: 'user-orders',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/orders'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/welcome/use_pc_page',
		name: 'use_pc_page',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/use_pc_page'),
	},
	{
		path: '/account/users/current',
		name: 'user-current',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/current'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/users/buy_member',
		name: 'user-by-member',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/buy_member'),
		meta: {
		}
	},
	{
		path: '/account/users/buy_member1',
		name: 'user-by-member-1',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/buy_member'),
		meta: {
		}
	},
	{
		path: '/account/vue_users',
		name: 'account-setting',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/account_setting'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/alter_user_name',
		name: 'alter_user_name',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/alter_user_name'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/alter_user_username',
		name: 'alter_user_username',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/alter_user_username'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/alter_user_community_identity',
		name: 'alter_user_community_identity',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/alter_user_community_identity'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/alter_phone',
		name: 'alter_user_phone',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/phone-info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/alter_user_avatar',
		name: 'alter_user_avatar',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/alter_user_avatar'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/privacy/company-list',
		name: 'privacy-company-list',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account-privacy/company-list'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/privacy/company-privacy',
		name: 'privacy-company',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account-privacy/company-privacy'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/expect-work',
		name: 'expect-work',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/expect-work'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/student-work-type',
		name: 'student-work-type',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/student_work_type'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/worker-state',
		name: 'worker-state',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/worker_state'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/follow-company',
		name: 'follow-company',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/follow-company'),
		meta: {
			isLogin: true
		}
	},
	// 设备管理
	{
		path: '/account/device',
		name: 'account-device',
		component: () => import(/* webpackChunkName: "account-device" */ '@/views/account/device'),
		meta: {
			isLogin: true
		}
	},

	{
    // 支付类型
		path: '/pay/type',
		name: 'payType',
		component: () => import(/* webpackChunkName: "account" */ '@/views/pay/PayType'),
		meta: {
			isLogin: false
		}
	},{
    // 微信支付
		path: '/pay/wechat',
		name: 'payWechat',
		component: () => import(/* webpackChunkName: "account" */ '@/views/pay/WechatPay'),
		meta: {
			isLogin: false
		}
	},{
    // 支付成功
		path: '/pay/wechat/success',
		name: 'payWechatSuccess',
		component: () => import(/* webpackChunkName: "account" */ '@/views/pay/pay-success'),
		meta: {
			isLogin: false
		}
	},{
    // 扫码后再创建订单
		path: '/pay/create-order',
		name: 'payCreateOrder',
		component: () => import(/* webpackChunkName: "account" */ '@/views/pay/PayCreateOrder'),
		meta: {
			isLogin: true
		}
	},{
		path: '/account/discuss',
		name: 'accountDiscuss',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/discuss'),
		meta: {
			isLogin: true
		}
	},{
		path: '/system/message',
		name: 'systemMessage',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/systemMessage'),
		meta: {
			isLogin: true
		}
	},{
		path: '/account/users/:identity/invite',
		name: 'accountUserInvitation',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation/invitation'),
		meta: {
			isLogin: false
		}
	},
	// {
	// 	path: '/account/users/:identity/new_invite',
	// 	name: 'accountUserNewInvitation',
	// 	component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation/new_invitation'),
	// 	meta: {
	// 		isLogin: false
	// 	}
	// },
	// {
	// 	path: '/invite/fromFriends/:identity',
	// 	name: 'inviteFromFriends',
	// 	component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation/from_friends'),
	// 	meta: {
	// 		isLogin: false
	// 	}
	// },
	{
		path: '/groups/:groupToken/invite',
		name: 'groupInvitation',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation/group_invitation'),
		meta: {
			diffShare: true
		}
	},{
		path: '/group/invitation/success',
		name: 'groupInvitationSuccess',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation/group_invitation_success'),
		meta: {
			isLogin: false
		}
   },{
		path: '/buy/member/order',
		name: 'buyMemberOrder',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/buy_member_order'),
		meta: {
			isLogin: true
		}
	},{
		path: '/wechat/open/app',
		name: 'wechatOpenApp',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/wechatOpenApp'),
		meta: {
			isLogin: false
		}
	},{
		path: '/invite_transfer/:identity',
		name: 'inviteTransferIdentity',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/invite_transfer/index'),
		meta: {
			isLogin: false
		}
	},{
	// 扫码登录确认页面
		path: '/scan_login',
		name: 'scanLogin',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/scanLogin/scanLogin'),
		meta: {
			isLogin: true
		}
	},
	// 负责接收消息的页面
	{
		path: '/plugin_v/receive-message',
		name: 'webReceiveMessage',
		component: () => import(/* webpackChunkName: "account" */ '@/views/receive-message/index'),
		meta: {
			isLogin: false
		}
	}
]

export default accountRouter
